import React from "react";

const Pause = ({ disabled = false}) => {
  return disabled ? (
  <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<g>
<rect x="2" y="1" width="40" height="40" rx="16" fill="#EBEBED"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M14.5 16.5C14.5 14.8431 15.8431 13.5 17.5 13.5H26.5C28.1569 13.5 29.5 14.8431 29.5 16.5V25.5C29.5 27.1569 28.1569 28.5 26.5 28.5H17.5C15.8431 28.5 14.5 27.1569 14.5 25.5V16.5Z" fill="#F6F6F6"/>
</g>
<defs>
<filter id="filter0_dd_411_28319" x="0" y="0" width="44" height="44" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.356863 0 0 0 0 0.407843 0 0 0 0 0.443137 0 0 0 0.32 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_411_28319"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="0.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.101961 0 0 0 0 0.12549 0 0 0 0 0.141176 0 0 0 0.32 0"/>
<feBlend mode="normal" in2="effect1_dropShadow_411_28319" result="effect2_dropShadow_411_28319"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_411_28319" result="shape"/>
</filter>
</defs>
</svg>

  ) : (
  <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<g>
<rect x="2" y="1" width="40" height="40" rx="16" fill="#E7000B"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M14.5 16.5C14.5 14.8431 15.8431 13.5 17.5 13.5H26.5C28.1569 13.5 29.5 14.8431 29.5 16.5V25.5C29.5 27.1569 28.1569 28.5 26.5 28.5H17.5C15.8431 28.5 14.5 27.1569 14.5 25.5V16.5Z" fill="white"/>
</g>
<defs>
<filter id="filter0_dd_411_32618" x="0" y="0" width="44" height="44" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.356863 0 0 0 0 0.407843 0 0 0 0 0.443137 0 0 0 0.32 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_411_32618"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="0.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.101961 0 0 0 0 0.12549 0 0 0 0 0.141176 0 0 0 0.32 0"/>
<feBlend mode="normal" in2="effect1_dropShadow_411_32618" result="effect2_dropShadow_411_32618"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_411_32618" result="shape"/>
</filter>
</defs>
</svg>

  );
};

export default Pause;